
import Component, { mixins } from "vue-class-component";
import { Pie, mixins as chartMixins } from "vue-chartjs";
import { Prop } from "vue-property-decorator";

@Component({
    mixins: [chartMixins.reactiveProp],
})
export default class DoughnutChart extends mixins(Pie) {
	@Prop() chartData: any;
    mounted() {
        this.renderChart(
            this.chartData,
            { 
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					enabled: true,
					callbacks: {
						label:function (tooltipItem, data) {
							let dataset = data.datasets[tooltipItem.datasetIndex]
							let currentValue = `${dataset.label[tooltipItem.index]}: ${Number(dataset.data[tooltipItem.index]).toFixed(2)}%`
							return currentValue;
						}
					}
				}
			}
        );
    }
}
